import React from 'react';
import styles from './Partners.module.css';
import bigCommerce from './Logos/big-commerce.png';
import facebook from './Logos/facebook.png';
import googleSheets from './Logos/google-sheets.png';
import klaviyo from './Logos/klaviyo.png';
import zapier from './Logos/zapier.png';
import woogCommerce from './Logos/woo-commerce.png';
import shopify from './Logos/shopify.png';
import salesforce from './Logos/salesforce.png';
import highLevel from './Logos/highlevel.png';

export const Partners = () => {
  const images = [
    shopify,
    facebook,
    klaviyo,
    zapier,
    googleSheets,
    woogCommerce,
    bigCommerce,
    salesforce,
    highLevel,
  ];
  return (
    <div className={styles.container}>
      <div className={styles.heading}>Integrate directly with</div>
      <div className={styles.logos}>
        {images.map(img => (
          <img src={img} key={img} />
        ))}
      </div>
    </div>
  );
};
